<script>
  import { navigating, page } from "$app/stores";
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import { customer } from "$lib/state/customer";
  import { onMount } from "svelte";
  import { bodyScroll } from "$lib/utils/PreventBodyScroll.js";
  import { loading } from "$lib/state/loader.js";
  import schema from './schema.json';
  import Footer from "$lib/components/layout/Footer.svelte";
  import Header from "$lib/components/layout/Header.svelte";
  import Analytics from "$lib/utils/Analytics.svelte";
  import GoogleTag from "$lib/utils/GoogleTag.svelte";
  import Loader from "$lib/components/layout/Loader.svelte";

  export let data;
  // @ts-ignore
  customer.set(data.customerInfo);
  cart.set(data.cartInfo);
  cartTotals.set(data.cartTotals);
  
  /**
   * Privacy code start
   **/
  /**@type {boolean}*/
  let isPrivacyLoading = false;
  /**@type {HTMLDialogElement}*/
  let proposal;
  /**@param {boolean}isPrivacy*/
  function setPrivacy(isPrivacy) {
    if (isPrivacy) {
      proposal?.close();
      document.cookie = `privacy-proposal = true; expires = ${new Date().getUTCDate()}; path=/`;
      isPrivacyLoading = true;
    } else {
      proposal?.close();
      document.cookie = `privacy-proposal = false; expires = ${new Date().getUTCDate()}; path=/`;
      isPrivacyLoading = false;
    }
    bodyScroll.allow();
  }

  onMount(() => {
    if (!data.privacy) {
      proposal?.showModal();
      bodyScroll.prevent();
    }
    if (data.privacy == "false") {
      isPrivacyLoading = false;
    } else {
      isPrivacyLoading = true;
    }
  });

  $: loading.setNavigate(!!$navigating);

</script>

<svelte:head>
  <title>{$page.data.title || "RCM"}</title>
   <!--Schema Script-->
   {@html `<script type="application/ld+json">${JSON.stringify(schema)}</script>`}
   <!--END Schema Script-->
  <script async defer src="https://www.recaptcha.net/recaptcha/api.js?render=6Lei0pobAAAAAKC5zB-TGn72-zt5IohwP3S3pCJe">
  </script>
</svelte:head>
{#if isPrivacyLoading}
  <Analytics />
  <GoogleTag />
{/if}

<Header />
<Loader />
<main>
  <slot />
</main>
<div class="footer">
  <Footer />
</div>
<!-- Privacy proposal -->
<dialog bind:this={proposal} class="proposal" hidden={data?.privacy === "true"}>
  <div class="privacy-proposal">
    <div class="text">
      <h3>Privacy Policy</h3>
      <p>
        We use cookies for our Google Analytics, Facebook likes, and to keep an
        anonymized session. You can find more out or privacy policy here:
        <a href="/privacy-policy" aria-labelledby="privacy">Privacy Policy.</a>
        <span id="privacy" class="label">Go to Privacy Policy</span>
      </p>
    </div>
    <div class="butons">
      <button
        class="btn-action-url"
        aria-labelledby="no-thanks"
        on:click={() => setPrivacy(false)}
        aria-label="No, thanks."
      >
        <span id="no-thanks" class="label">No, thanks.</span>
        <span>No, thanks.</span>
      </button>
      <button
        class="btn-action-url"
        aria-labelledby="yes-thanks"
        on:click={() => setPrivacy(true)}
        aria-label="It´s Okay."
      >
        <span id="yes-thanks" class="label">It´s Okay.</span>
        <span>It´s Okay.</span>
      </button>
    </div>
  </div>
</dialog>

<style>
  main, .footer{
    position: relative;
  }
  main{
    z-index: 0;
  }
  .footer{
    z-index: 0;
  }
  .proposal {
    width: 90svw;
    max-width: 520px;
    padding: 3rem 4rem 3rem 2.5rem;
    border: none;
    background-color: var(--orange-light);
    border-radius: 2rem 0 0 2rem;
    bottom: 10px;
    top: inherit;
    right: 0;
    left: inherit;
    animation: privacy 1s ease forwards;
  }
  @keyframes privacy {
    from {
      right: -100%;
      opacity: 0;
    }
    to {
      right: 0;
      opacity: 1;
    }
  }
  .proposal .privacy-proposal .text h3 {
    font-size: 3rem;
    font-family: sirenia;
    color: var(--orange);
  }
  .proposal .privacy-proposal .text p {
    font-size: 1.8rem;
    color: var(--orange);
    line-height: 1.2;
    padding: 2rem 0;
  }
  .proposal .privacy-proposal .text a {
    color: var(--pink);
    text-decoration: none;
    font-weight: 700;
    line-height: 1.2;
  }
  .proposal .privacy-proposal .butons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
</style>
